


export const AreStoreAreComponentMetaKeys ={
    StoreExtensions: '_AreStore_StoreExtensions',
} as const